const a = [
  { date: '1/1/20 00:00', sepp_production: 0 },
  { date: '1/1/20 01:00', sepp_production: 0 },
  { date: '1/1/20 02:00', sepp_production: 0 },
  { date: '1/1/20 03:00', sepp_production: 0 },
  { date: '1/1/20 04:00', sepp_production: 0 },
  { date: '1/1/20 05:00', sepp_production: 0 },
  { date: '1/1/20 06:00', sepp_production: 0 },
  { date: '1/1/20 07:00', sepp_production: 0 },
  { date: '1/1/20 08:00', sepp_production: 0 },
  { date: '1/1/20 09:00', sepp_production: 0.776806819 },
  { date: '1/1/20 10:00', sepp_production: 12.0597786 },
  { date: '1/1/20 11:00', sepp_production: 19.15603498 },
  { date: '1/1/20 12:00', sepp_production: 16.79029605 },
  { date: '1/1/20 13:00', sepp_production: 22.85607929 },
  { date: '1/1/20 14:00', sepp_production: 11.44346167 },
  { date: '1/1/20 15:00', sepp_production: 14.09012383 },
  { date: '1/1/20 16:00', sepp_production: 13.41143261 },
  { date: '1/1/20 17:00', sepp_production: 4.029305741 },
  { date: '1/1/20 18:00', sepp_production: 0 },
  { date: '1/1/20 19:00', sepp_production: 0 },
  { date: '1/1/20 20:00', sepp_production: 0 },
  { date: '1/1/20 21:00', sepp_production: 0 },
  { date: '1/1/20 22:00', sepp_production: 0 },
  { date: '1/1/20 23:00', sepp_production: 0 },
  { date: '1/2/20 00:00', sepp_production: 0 },
  { date: '1/2/20 01:00', sepp_production: 0 },
  { date: '1/2/20 02:00', sepp_production: 0 },
  { date: '1/2/20 03:00', sepp_production: 0 },
].map((d) => ({ ...d, sepp_fixed: d.sepp_production }))

const date = a.map(({ date }) => date)
const sepProduction = a.map(({ sepp_production }) => sepp_production)
const seppFixed = a.map(({ sepp_production }) => sepp_production)

console.log(date)
console.log(sepProduction)
console.log(seppFixed)

export default a
